import React from 'react';
import { useSelector } from 'react-redux';
import { t } from 'i18next';
import { string, bool } from 'prop-types';
import cn from 'classnames';

import { PAYMENT_CARD_ICONS, PAYMENT_METHODS_INFO, PAYMENT_METHODS } from '~constants/paymentMethods';
import { CURRENT_COUNTRY_ID } from '~constants/environment';
import { DISPATCH_METHODS } from '~constants/address';

import styles from './styles.module.scss';

function SelectedMethod({ selectedPaymentMethod, creditCardKind, cardNumber, paymentMethodError }) {
  const dispatchMethod = useSelector(state => state.searchStore?.dispatchType);
  const isDelivery = dispatchMethod === DISPATCH_METHODS.PJ_DELIVERY;
  const method = Object.values(PAYMENT_METHODS_INFO[CURRENT_COUNTRY_ID]).find(
    m => m.name === selectedPaymentMethod
  );
  const methodName = () => {
    if (selectedPaymentMethod === PAYMENT_METHODS.card && isDelivery) {
      return t('CheckoutPaymentMethodList:delivery_card');
    }
    return t(`CheckoutPaymentMethodList:${method?.name || 'mustChooseMethod'}`);
  };
  const cardIcon = creditCardKind && PAYMENT_CARD_ICONS[creditCardKind];

  return (
    <div className={cn('row middle', { [styles.errorBox]: paymentMethodError })}>
      {(method || cardIcon) && (
        <img
          className={cn('m-right-1', { [styles.edenredIcon]: method?.name === PAYMENT_METHODS.edenred })}
          width={25}
          src={cardIcon || method?.icon}
          alt={cardNumber || methodName()}
        />
      )}
      {cardNumber || methodName()}
    </div>
  );
}

SelectedMethod.propTypes = {
  cardNumber: string,
  creditCardKind: string,
  paymentMethodError: bool,
  selectedPaymentMethod: string
};

export default SelectedMethod;
